function productSelectGlobal($selectGlobal, formVariantId) {
  if ($selectGlobal.length) {
    if (formVariantId != undefined) {
      $selectGlobal.find(`option[value="${formVariantId}"]`).prop('selected', 'selected')
    };

    for (let i = 1; i <= 3; i++) {
      const globalValues = $selectGlobal.find(`option:selected`).data(`option-${i}`);
      const $form = $selectGlobal.closest('form');

      if (globalValues != '') {
        const $target = $form.find(`[data-option="${i}"][data-value="${globalValues}"]`);

        if ($target.closest('.js-radio-color').length) {
          $target.prop('checked', 'checked');
        } else {
          $target.prop('selected', 'selected');

          if ($target.closest('.js-select-custom').length) {
            $target.closest('.js-select-custom select').selectric('refresh');
          };
        }
      };
    };
  };
}

module.exports = {
  productSelectGlobal
};



// WEBPACK FOOTER //
// ../assets/js/product-select-global.js